export default __webpack_public_path__ + "static/media/hotels-catering-news-middle-east.5eacb4f6.png";